(() => {
if (typeof CookieConsent !== 'undefined') CookieConsent.run({
    revision: 1,
    guiOptions: {
        consentModal: {
            layout: "box",
            position: "bottom right",
            equalWeightButtons: false,
            flipButtons: false
        },
        preferencesModal: {
            layout: "box",
            position: "left",
            equalWeightButtons: true,
            flipButtons: false
        }
    },
    categories: {
        necessary: {
            readOnly: true // this category cannot be disabled
        },
        analytics: {},
        marketing: {}
    },
    onConsent: ({ cookie: cookie })=>{
        $eeca6d65ffe86aff$var$onConsentCallback();
    },
    onChange: ({ cookie: cookie, changedCategories: changedCategories, changedPreferences: changedPreferences })=>{
        $eeca6d65ffe86aff$var$onConsentCallback();
    },
    language: {
        default: window.cookieConsentLocale || 'fi',
        translations: function() {
            // Translations are injected by cookie-consent-translations.njk as window.cookieConsentTranslations.
            // Falls back to a minimal English translation if not available (e.g. localhost without a full build).
            var locale = window.cookieConsentLocale || 'en';
            var data = window.cookieConsentTranslations || {
                consentModal: {
                    title: '',
                    description: 'We use cookies to personalise content and marketing, to provide social media features and to analyse our traffic. By clicking "Accept All", you agree to the use of cookies.',
                    acceptAllBtn: 'Accept all',
                    showPreferencesBtn: 'Manage preferences'
                },
                preferencesModal: {
                    title: 'Consent Preferences Center',
                    closeIconLabel: 'Close modal',
                    acceptAllBtn: 'Accept all',
                    savePreferencesBtn: 'Save preferences',
                    sections: [
                        {
                            linkedCategory: 'necessary',
                            title: 'Strictly Necessary cookies <span class="pm__badge">Always Enabled</span>',
                            description: 'These cookies are required for the website to function.'
                        },
                        {
                            linkedCategory: 'analytics',
                            title: 'Analytics Cookies',
                            description: 'Help us understand how visitors use the site.'
                        },
                        {
                            linkedCategory: 'marketing',
                            title: 'Marketing Cookies',
                            description: 'Used to show relevant advertisements.'
                        }
                    ]
                }
            };
            var translations = {};
            translations[locale] = data;
            return translations;
        }()
    },
    disablePageInteraction: false
});
/**
 * We could add other consensual data gathering triggers here as well.
 */ function $eeca6d65ffe86aff$var$onConsentCallback() {
    // Use the global gtag function defined by google.njk.
    // If gtag is not available (e.g. localhost without GA loaded), skip gracefully.
    if (typeof gtag !== 'function') return;
    const preferences = CookieConsent.getUserPreferences();
    if (preferences.acceptedCategories.includes('analytics')) gtag('consent', 'update', {
        'analytics_storage': 'granted'
    });
    else gtag('consent', 'update', {
        'analytics_storage': 'denied'
    });
    if (preferences.acceptedCategories.includes('marketing')) {
        gtag('consent', 'update', {
            'ad_storage': 'granted'
        });
        gtag('consent', 'update', {
            'ad_user_data': 'granted'
        });
        gtag('consent', 'update', {
            'ad_personalization': 'granted'
        });
    } else {
        gtag('consent', 'update', {
            'ad_storage': 'denied'
        });
        gtag('consent', 'update', {
            'ad_user_data': 'denied'
        });
        gtag('consent', 'update', {
            'ad_personalization': 'denied'
        });
    }
}

})();
//# sourceMappingURL=cookie-consent.js.map
